import {ReactNode} from "react";
import {bool} from "yup";

export default function FlintFieldset(props: FlintFieldsetProps) {
    const className = props.marginBottom ? `vivo-fieldset mb-${props.marginBottom}` : "vivo-fieldset mb-5";
    return (
        <fieldset className={className}>
            {props.legend &&
                <>
                    {props.showLegendBorder &&
                    <legend className={"h6 color-primary border-bottom pb-2"}>{props.legend}</legend>}
                    {!props.showLegendBorder &&
                    <legend className={"h6 color-primary"}>{props.legend}</legend>}
                </>
            }
            {props.children}
        </fieldset>
    )
}

export interface FlintFieldsetProps {
    children: ReactNode;
    legend?: string,
    showLegendBorder?: boolean,
    // 0-5, auto (bootstrap notation - just suffix for mb-*) 
    marginBottom?: number | "auto";
}